import React, { forwardRef, JSX } from 'react';
import { cn } from '@samera-one/helpers';

// Reusable helper to create components with consistent structure
const createComponent = <T extends HTMLElement>(
  tag: keyof JSX.IntrinsicElements,
  defaultClassName: string,
  displayName: string,
) => {
  const Component = forwardRef<T, React.HTMLAttributes<T>>((props, ref) => {
    return React.createElement(
      tag,
      { ...props, ref, className: cn(defaultClassName, props.className) },
      props.children,
    );
  });
  Component.displayName = displayName;
  return Component;
};

/** @deprecated Use Typography from './typography-v2/typography' instead */
export const H1 = createComponent<HTMLHeadingElement>(
  'h1',
  'scroll-m-20 text-4xl font-extrabold tracking-tight lg:text-5xl',
  'H1',
);

/** @deprecated Use Typography from './typography-v2/typography' instead */
export const H2 = createComponent<HTMLHeadingElement>(
  'h2',
  'scroll-m-20 border-b py-2 text-3xl font-semibold tracking-tight first:mt-0',
  'H2',
);

/** @deprecated Use Typography from './typography-v2/typography' instead */
export const H3 = createComponent<HTMLHeadingElement>(
  'h3',
  'scroll-m-20 text-2xl font-semibold tracking-tight',
  'H3',
);

/** @deprecated Use Typography from './typography-v2/typography' instead */
export const H4 = createComponent<HTMLHeadingElement>(
  'h4',
  'scroll-m-20 text-xl font-semibold tracking-tight',
  'H4',
);

/** @deprecated Use Typography from './typography-v2/typography' instead */
export const Lead = createComponent<HTMLParagraphElement>(
  'p',
  'text-xl text-muted-foreground',
  'Lead',
);

/** @deprecated Use Typography from './typography-v2/typography' instead */
export const P = createComponent<HTMLParagraphElement>(
  'p',
  'leading-7 [&:not(:first-child)]:mt-6',
  'P',
);

/** @deprecated Use Typography from './typography-v2/typography' instead */
export const Large = createComponent<HTMLDivElement>(
  'div',
  'text-lg font-semibold',
  'Large',
);

/** @deprecated Use Typography from './typography-v2/typography' instead */
export const Small = createComponent<HTMLParagraphElement>(
  'p',
  'text-sm font-medium leading-none',
  'Small',
);

/** @deprecated Use Typography from './typography-v2/typography' instead */
export const Muted = createComponent<HTMLSpanElement>(
  'span',
  'text-sm text-muted-foreground',
  'Muted',
);

/** @deprecated Use Typography from './typography-v2/typography' instead */
export const InlineCode = createComponent<HTMLSpanElement>(
  'code',
  'relative rounded bg-muted px-[0.3rem] py-[0.2rem] font-mono text-sm font-semibold',
  'InlineCode',
);

/** @deprecated Use Typography from './typography-v2/typography' instead */
export const MultilineCode = createComponent<HTMLPreElement>(
  'pre',
  'relative rounded bg-muted p-4 font-mono text-sm font-semibold overflow-x-auto',
  'MultilineCode',
);

/** @deprecated Use Typography from './typography-v2/typography' instead */
export const List = createComponent<HTMLUListElement>(
  'ul',
  'my-6 ml-6 list-disc [&>li]:mt-2',
  'List',
);

/** @deprecated Use Typography from './typography-v2/typography' instead */
export const Quote = createComponent<HTMLQuoteElement>(
  'blockquote',
  'mt-6 border-l-2 pl-6 italic text-muted-foreground',
  'Quote',
);
